import {http} from "@/assets/utils/api";

/**
 * 错题集
 * @param {*} data 
 * @returns 
 */
export const getWrongQuestionList = (data) => http.post('/questionYymCourseQuestion/errorQuestion',data);

/**
 * 错题集
 * @param {*} data 
 * @returns 
 */
export const getWrongQuestionListPage = (data) => http.post('/questionYymCourseQuestion/errorQuestionPage',data);

/**
 * 记录视频学习
 */
export const recordVideoSegment = (data) => http.post('/yymCourseUserChapterProgress/recordVideoSegment',data);

/**
 * 进行中/已完成课程统计
 */
export const getStudyProgress = (params) => http.get('/yymCourseUser/getStudyProgressNumCount',{params});

/**
 * 学习习惯（每天学习时长统计）
 */
export const statisticsListForDay = (params) => http.get('/yymCourseUserChapterLog/statisticsListForDay',{params});

/**
 * 学习记录
 */
export const getLearningRecord = (params) => http.get('/yymCourseUserChapterLog/getMyList',{params});

/**
 * 批量查询我的课程学习进度
 */
export const getMycourseListProgress = (params) => http.get('/yymCourseUserChapterProgress/getChapterProgressCountResultsByCourseIds',{params});

/**
 * 查询所有参与课程平均学习进度
 */
export const getAllMycourseListProgress = (params) => http.get('/yymCourseUserChapterProgress/getAvgProgressByMyJoinCourse',{params});

/**
 * 查询课程下所有章节学习进度
 */
export const getChapterProgress = (params) => http.get('/yymCourseUserChapterProgress/getMyAll',{params});

/**
 * 获取错题（五步-纠错）
 */
export const getMyCourseWrongQuestion = (params) => http.get('/examPaperRecord/getWrongQuestions',{params});

/**
 * 知识点统计（五步-纠错）
 */
export const getMyKnowledgeCount = (courseId,schemeId,roundId,phaseId,chapterId) => http.get(`/examPaperRecord/getKnowledgeCount/${courseId}/${schemeId}/${roundId}/${phaseId}/${chapterId}`);

/**
 * 主动触发记录当前学习进度
 */
export const recordPhaseProgress = (data) => http.post('/yymCourseUserChapterProgress/recordUserPhaseProgress',data);

/**
 * 主动触发完成输入阶段（用于直播模式）
 */
export const confirmPassInputStatus = (data) => http.post('/yymCourseUserChapterProgress/confirmPassInputStatus',data);

/**
 * 同步纠错状态
 */
export const checkWrongStateStatus = (params) => http.get('/progress/checkWrongStage',{params});